import { all } from 'redux-saga/effects';
import authenticationSaga from './authentication/saga';
import claimSaga from './claim/saga';
import claimAuthorizationsSaga from './claimAuthorizations/saga';
import claimsSaga from './claims/saga';
import configSaga from './config/saga';
import externalContactsSaga from './externalContacts/saga';
import fileContainersSaga from './fileContainers/saga';
import fileUploadSaga from './fileUpload/saga';
import filtersSaga from './filters/saga';
import generalMessagesSaga from './generalMessages/saga';
import housingStocksSaga from './housingStocks/saga';
import importSaga from './import/saga';
import insuredRisksSaga from './insuredRisks/saga';
import insuredRisksToPoliciesSaga from './insuredRisksToPolicies/saga';
import messageTemplatesSaga from './messageTemplates/saga';
import organizationsSaga from './organizations/saga';
import organizationsToRisksSaga from './organizationsToRisks/saga';
import passwordSaga from './password/saga';
import policiesSaga from './policies/saga';
import policiesToRisksSaga from './policiesToRisks/saga';
import policySaga from './policy/saga';
import reportingSaga from './reporting/saga';
import riskSaga from './risk/saga';
import risksSaga from './risks/saga';
import blobsToOrganizationsSaga from './blobsToOrganizations/saga';
import settlementsSaga from './settlements/saga';
import stripeSaga from './stripe/saga';
import usersSaga from './users/saga';
import worklistClaimsSaga from './worklistClaims/saga';
import worklistRisksSaga from './worklistRisks/saga';
import worklistsSaga from './worklists/saga';

export default function* rootSaga() {
  yield all([
    authenticationSaga(),
    claimSaga(),
    claimAuthorizationsSaga(),
    claimsSaga(),
    configSaga(),
    externalContactsSaga(),
    fileContainersSaga(),
    fileUploadSaga(),
    filtersSaga(),
    generalMessagesSaga(),
    housingStocksSaga(),
    importSaga(),
    insuredRisksSaga(),
    insuredRisksToPoliciesSaga(),
    messageTemplatesSaga(),
    organizationsSaga(),
    organizationsToRisksSaga(),
    passwordSaga(),
    policiesSaga(),
    policiesToRisksSaga(),
    policySaga(),
    reportingSaga(),
    riskSaga(),
    risksSaga(),
    blobsToOrganizationsSaga(),
    settlementsSaga(),
    stripeSaga(),
    usersSaga(),
    worklistClaimsSaga(),
    worklistRisksSaga(),
    worklistsSaga()
  ]);
}
